

















































































import Vue from 'vue';
import CommunityGroupThumbnail from '@/web/components/community/CommunityGroupThumbnail.vue';
import CommunityMembersModal from '@/web/views/admin/community/CommunityMembersModal.vue';
import CommunityGroupFormModal from '@/web/views/admin/community/CommunityGroupFormModal.vue';
import { errorToMessage } from '@/core/utils/errors';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { cloneDeep } from 'lodash';
import VClamp from 'vue-clamp';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'CommunityGroupCard',
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      required: true,
    },
  },
  components: {
    CommunityGroupThumbnail,
    VClamp,
  },
  computed: mapGetters({
    teacherStudioUrl: 'user/teacherStudioUrl',
    teacherMagicCode: 'user/teacherMagicCode',
  }),
  methods: {
    async openEditGroupModal(group) {
      this.$modal.show(
        CommunityGroupFormModal,
        {
          group: Object.assign({}, group),
          confirm: this.editGroup,
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
    viewGroupMembers(group) {
      this.$modal.show(CommunityMembersModal, {
        group,
      });
    },
    viewFlaggedComments(groupId) {
      this.$router.push({
        name: 'community-flagged-comments',
      });
    },
    setGroupDescription(groupId) {
      this.$router.push({
        name: 'community-group-description',
        params: { group_id: groupId },
      });
    },
    async archiveGroup(group) {
      try {
        this.inProcess = true;
        await this.$store.dispatch('community/archiveGroup', {
          id: group.id,
          active: false,
        });
        group.active = false;

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.GROUP_WAS_SUCCESSFULLY_ARCHIVED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }
    },
    async unArchiveGroup(group) {
      try {
        this.inProcess = true;
        await this.$store.dispatch('community/archiveGroup', {
          id: group.id,
          active: true,
        });
        group.active = true;

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.GROUP_WAS_SUCCESSFULLY_UNARCHIVED'
          ),
        });
      } catch (error) {
        this.$emit('showUpgradeYourPlanModal');
      } finally {
        this.inProcess = false;
      }
    },
    async editGroup(group) {
      console.log('edit group', group);
      try {
        this.inProcess = true;
        await this.$store.dispatch('community/editGroup', {
          id: group?.id,
          group_name: group?.group_name,
          cover_photo: group?.cover_photo?.id || null,
          thumbnail_photo: group?.thumbnail_photo?.id || null,
          products: formatObjectForBackend(cloneDeep(group?.products)),
          hashtags_enabled: group?.hashtags_enabled,
          hashtags: group?.hashtags,
          display_members: group?.display_members,
          is_free: group?.is_free,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.GROUP_WAS_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }
      this.$emit('loadGroups');
    },
    viewGroup(data) {
      if (!data.active) return;
      const route = this.$router.resolve({
        name: 'studio-community-group',
        params: {
          group_id: data.id,
          studio_url: this.teacherStudioUrl,
        },
      });
      const routeUrl = route.href.replaceAll(`${this.teacherStudioUrl}/`, '');
      const url = getStudentViewURL(
        this.teacherStudioUrl,
        routeUrl,
        this.teacherMagicCode
      );

      window.open(url, '_blank');
    },
  },
});
